import { render, staticRenderFns } from "./Lecture.vue?vue&type=template&id=9fd1193c&"
import script from "./Lecture.vue?vue&type=script&lang=ts&"
export * from "./Lecture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports